var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"occupat-choice"},[_c('div',{staticClass:"occupat-choice-title"},[_c('div',[_vm._v("多领域职业选择，个人发展快人一步")]),_c('p',[_vm._v("全流程快捷学习，培养复合型人才")])]),_c('div',{staticClass:"occupat-choice-content"})])
}]

export { render, staticRenderFns }